<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div
            class="backgroud-white  cs-contentContainer-right-content cs-fullHeight"
          >
            <el-row>
              <el-col>
                <span class="cs-title">账号管理</span>

                <el-tabs v-model="activeTab" type="card" @tab-click="onTabClick">
                  <el-tab-pane name="1" v-if="USERMANAGER.isAdmin || USERMANAGER.isExecutiveManager || USERMANAGER.isPersonnelManagement">
                    <span slot="label"> 行政账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <receptionistList category="1"></receptionistList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <el-tab-pane name="2" v-if="USERMANAGER.isAdmin || USERMANAGER.isAcademicDirector || USERMANAGER.isPersonnelManagement || USERMANAGER.isEducationalAssistant">
                    <span slot="label"> 老师账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <teacherManage :isActive="activeTab == '2'" :role="1"></teacherManage>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <el-tab-pane name="3" v-if="USERMANAGER.isAdmin || USERMANAGER.isAcademicDirector || USERMANAGER.isPersonnelManagement">
                    <span slot="label"> 助教账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <teacherManage :isActive="activeTab == '3'" :role="2"></teacherManage>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <el-tab-pane name="4" v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isPersonnelManagement">
                    <span slot="label"> 财务账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <receptionistList category="2"></receptionistList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <el-tab-pane name="5" v-if="USERMANAGER.isAdmin || USERMANAGER.isSAManager">
                    <span slot="label"> 真留账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <receptionistList category="3"></receptionistList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <el-tab-pane name="6" v-if="!USERMANAGER.isSAFinancialAssistant && !USERMANAGER.isEducationalAssistant">
                    <span slot="label"> 家长账号 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <parentAccountList />
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import receptionistList from "../../components/receptionist/receptionistList";
import teacherManage from "../../components/teacherAccount/teacherAndAssistantAccount";
//import financialManage from "../../components/receptionist/financialAccountList";

export default {
  data() {
    return {
      loading: false,
      activeTab: "1"
    };
  },
  components: {
    navigator,
    receptionistList,
    teacherManage,
    //financialManage
    parentAccountList: () => import("../../components/parentAccount/parentAccountList")
  },
  computed: {},
  created() {
    if (this.USERMANAGER.isAcademicDirector || this.USERMANAGER.isEducationalAssistant){
      this.activeTab = "2";
    }
    if (this.USERMANAGER.isFinancialManager){
      this.activeTab = "4";
    }
    if (this.USERMANAGER.isSAManager){
      this.activeTab = "5";
    }
    if (this.USERMANAGER.isSABusinessSales || this.USERMANAGER.isSABusinessAssistant){
      this.activeTab = "6";
    }
  },
  methods: {
    onTabClick(tab){

    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/accountManage.vue